export default __webpack_public_path__ + "static/media/asset_quantity.81d9f0c2.PNG";